import { useApiPostRequest } from '../hooks/useApiPostRequest';
import {
  POST_DASHBOARD_WIDGET_CONFIGURATION_PATH,
  PostDashboardWidgetConfigurationErrorDto,
  PostDashboardWidgetConfigurationRequestBodyData,
  PostDashboardWidgetConfigurationRequestPathVariables,
  PostDashboardWidgetConfigurationRequestQueryParams,
  PostDashboardWidgetConfigurationSuccessDto,
} from './types/widget';

export const usePostWidgetConfiguration = () => {
  return useApiPostRequest<
    PostDashboardWidgetConfigurationRequestPathVariables,
    PostDashboardWidgetConfigurationRequestQueryParams,
    PostDashboardWidgetConfigurationRequestBodyData,
    PostDashboardWidgetConfigurationSuccessDto,
    PostDashboardWidgetConfigurationErrorDto
  >(POST_DASHBOARD_WIDGET_CONFIGURATION_PATH);
};
